var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yoyo-container mx-auto min-h-screen" },
    [
      _c("navBar"),
      _c("div", { staticClass: "bg-white md:mx-4 p-2" }, [
        _c(
          "div",
          { staticClass: "text-xl font-bold text-center text-gray-900 mt-4" },
          [
            _vm._v(
              _vm._s(_vm.isZh ? _vm.articleInfo.title : _vm.articleInfo.titleEn)
            ),
          ]
        ),
        _c("div", {
          staticClass: "text-[14px] text-gray-800 p-4",
          domProps: {
            innerHTML: _vm._s(
              _vm.isZh ? _vm.articleInfo.content : _vm.articleInfo.contentEn
            ),
          },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }